import clientFetcher from '@finance/clientFetcher';
import { Temporal } from '@js-temporal/polyfill';
import { Document } from 'fluent-graphql';
import type { AccountTransfer, Errors } from '../types';

export interface CreateAccountTransferReturn {
  createAccountTransfer: AccountTransfer | Errors;
}

interface CreateAccountTransferVars {
  organizationId: string;
  input: unknown;
}

export default Document
  .mutation<CreateAccountTransferReturn, CreateAccountTransferVars>('CreateAccountTransfer')
    .variableDefinitions({ organizationId: 'ID!', input: 'CreateAccountTransferInput!' })
    .union('createAccountTransfer')
      .useVariables({ organizationId: 'organizationId', input: 'input' })
      .onEntity('AccountTransfer')
        .scalar('date', Temporal.PlainDate.from)
        .scalar('organizationId')
        .reference('sourceCurrencyId', 'Currency')
        .reference('targetCurrencyId', 'Currency')
        .reference('sourceAccountId', 'Account')
        .reference('targetAccountId', 'Account')
        .scalar('sourceAmount')
        .scalar('targetAmount')._
      .onTypedObject('NegativeAccountBalance')
        .scalar('name')
        .scalar('currencyName')
        .scalar('balanceAmount')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher)
  .afterExecution(({ createAccountTransfer: data }) => {
    if (data.__typename === 'AccountTransfer') {
      Document.clearQueries([
        'AccountTransfers',
        'AccountTransactions',
        'Accounts'
      ]);
    }
  });
